import { useSuspenseQuery } from '@tanstack/react-query';
import { settingsClient } from '@modules/Settings/client/settingsClient';
import { cacheKeys } from '@modules/Settings/config';



export type Params = {
};

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useSettings = (options: Partial<Options> = defaultOptions) => {
  const { data: { data: settings } = {}, status, error } = useSuspenseQuery({
    queryKey: [cacheKeys.getSettings],
    queryFn: () => settingsClient.getSettings(),
  });

  return {
    status,
    error,
    settings,
  };
};
